<!--
  The demo store's Promotions page: the shared PromotionsPage with fixtures behind it.

  Everything visible lives in components/promotions/PromotionsPage.vue, which the live
  portal mounts too. This file only supplies the data and says, where it matters, that
  nothing typed here is kept.
-->
<template>
  <PromotionsPage
    demo
    :promos="DEMO_PROMOS"
    :zones="DEMO_PROMO_ZONES"
    :coverage-options="DEMO_COVERAGE_OPTIONS"
    :prior-promo="prior"
    :readiness="readiness"
    :today="demoDateStr(0)"
    @draft-change="onDraft"
  />
</template>

<script setup>
import { ref, shallowRef } from 'vue'
import PromotionsPage from '@/components/promotions/PromotionsPage.vue'
import {
  DEMO_COVERAGE_OPTIONS, DEMO_PROMOS, DEMO_PROMO_ZONES,
  demoPriorPromo, demoReadiness,
} from '@/demo/promosDemo'
import { demoDateStr } from '@/api/demoData'

const prior = shallowRef(null)
const readiness = ref(null)

/**
 * The page recomputes its readiness from the draft and announces it; the demo answers
 * from the same local function the fixtures use, where the portal asks the API. Same
 * shape either way, so the page cannot tell them apart.
 */
function onDraft(d) {
  prior.value = demoPriorPromo(d.zone)
  readiness.value = demoReadiness(d)
}
</script>
